import './vendor';
import vars from './helpers';
import Swiper, { Navigation, Pagination, Scrollbar, Lazy } from 'swiper';
import { fancybox } from '@fancyapps/fancybox';
import inputmask from 'inputmask/dist/jquery.inputmask';
import Handlebars from 'handlebars';
import noUiSlider from 'nouislider';
import wNumb from 'wnumb';
import WOW from 'wow.js';
import LazyLoad from 'vanilla-lazyload';

Swiper.use([Navigation, Pagination, Scrollbar, Lazy]);

const $document = $(document);

const $window = $(window);

const $html = $('html');

const $body = $('body');

const lazyLoadInstance = new LazyLoad({});

const app = {
	isMobile: () => $window.outerWidth() < 1024,
	global: {
		init() {
			$('.js-goto').on('click', (e) => {
				let $target = $($(e.currentTarget).data('target') || $(e.currentTarget).attr('href'));

				if ($target.length) {
					e.preventDefault();
					window.scrollTo(0, $target.offset().top - 120);
					$html.removeClass('is-show-menu');
				}
			});

			$('[data-fancybox]').fancybox({
				autoFocus: false,
				backFocus: false,
				touch: false,
			});

			$document.on('click', '.js-toggle-class', (e) => {
				e.preventDefault();

				let options = $(e.currentTarget).data();

				switch (options.type) {
					case 'add':
						$html.addClass(options.class);
						break;
					case 'remove':
						$html.removeClass(options.class);
						break;
					case 'toggle':
						$html.toggleClass(options.class);
						break;
					default:
						$html.toggleClass(options.class);
						break;
				}
			});

			$('.js-show-hide').on('click', (e) => {
				let $this = $(e.currentTarget);

				let $target = $($this.data('target'));

				e.preventDefault();
				if ($target.length) {
					$this.toggleClass('is-active');
					if ($this.hasClass('is-active')) {
						$target.stop().slideDown(500);
						$this.find('span').text($this.data('on'));
					} else {
						$target.stop().slideUp(500);
						$this.find('span').text($this.data('off'));
					}
				}
			});

			$('.js-print').on('click', (e) => {
				e.preventDefault();
				window.print();
			});

			$document.on('click', '.js-live-fancybox', (e) => {
				e.preventDefault();

				$.fancybox.open({
					src: $(e.currentTarget).attr('href'),
					opts: {
						autoFocus: false,
						backFocus: false,
						touch: false,
					},
				});
			});

			$('head').append(`<style type="text/css">
				html {
					--compensate-scrollbar:${(window.innerWidth - document.documentElement.clientWidth) / -2}px;
				}
				</style>`);
			
            new WOW().init();
		},
	},
	header: {
		init($header) {
			let fixed = false;
			const $line = $header.find('.header__menu__line');
			let checkLine;
			const checkActive = () => {
				$header.find('.header__menu ul a').each((index, item) => {
					const $item = $(item);

					if ($item.attr('href')[0] === '#') {
						const $target = $($item.attr('href'));
	
						$item.removeClass('is-active');
						if ($target.length) {
							if ($window.scrollTop() + $window.outerHeight() / 2 > $target.offset().top && $window.scrollTop() + $window.outerHeight() / 2 < $target.offset().top + $target.outerHeight()) {
								$item.addClass('is-active');
							}
						}
					}
				});

				clearTimeout(checkLine);
				checkLine = setTimeout(() => {
					if ($line.is(':visible')) {
						let $active = $header.find('.header__menu ul a').filter('.is-active');

						if ($active.length) {
							$line.addClass('is-show');
							$line.css({
								left: $active.position().left,
								width: $active.outerWidth(),
							});
						} else {
							$line.css({
								width: 0,
							});
							$line.removeClass('is-show');
						}
					}
				}, 50);
			};

			$window.on('scroll', () => {
				if ($window.scrollTop() > $header.outerHeight()) {
					if (!fixed) {
						$header.css({
							height: $header.outerHeight(),
						});
						$header.addClass('is-fixed');
						fixed = true;
					}
				} else if (fixed) {
					$header.removeClass('is-fixed');
					$header.css({
						height: '',
					});
					fixed = false;
				}
				checkActive();
			});

			$header.find('.header__menu ul a').hover(
				(e) => {
					let $this = $(e.currentTarget);

					if ($line.is(':visible')) {
						$line.addClass('is-show');
						$line.css({
							left: $this.position().left,
							width: $this.outerWidth(),
						});
					}
				},
				(e) => {
					let $active = $header.find('.header__menu ul a').filter('.is-active');

					if ($line.is(':visible')) {
						if ($active.length) {
							$line.addClass('is-show');
							$line.css({
								left: $active.position().left,
								width: $active.outerWidth(),
							});
						} else {
							$line.css({
								width: 0,
							});
							$line.removeClass('is-show');
						}
					}
				}
			);
		},
	},
	mask: {
		init($mask) {
			$mask.inputmask($mask.data('mask').toString(), {
				showMaskOnHover: false,
				clearIncomplete: true,
			});
		},
	},
	intro: {
		init($intro) {
			const $items = $intro.find('.intro__item');

			const slider = new Swiper($intro.find('.swiper-container')[0], {
				loop: true,
				speed: 1000,
				preloadImages: true,
				lazy: true,
				navigation: {
					prevEl: $intro.find('.intro__slider__prev')[0],
					nextEl: $intro.find('.intro__slider__next')[0],
				},
				pagination: {
					el: $intro.find('.intro__slider__pager')[0],
					clickable: true,
				},
			});

			slider.on('slideChange', () => {
				$items.removeClass('is-active');
				$items.eq(slider.realIndex).addClass('is-active');
			});
		},
	},
	benefit: {
		init($benefit) {
			const $items = $benefit.find('.benefit__content__item');

			const slider = new Swiper($benefit.find('.swiper-container')[0], {
				loop: true,
				preloadImages: true,
				lazy: true,
				navigation: {
					prevEl: $benefit.find('.benefit__image__prev')[0],
					nextEl: $benefit.find('.benefit__image__next')[0],
				},
				pagination: {
					el: $benefit.find('.benefit__image__pager')[0],
					clickable: true,
				},
			});

			slider.on('slideChange', () => {
				$items.removeClass('is-active');
				$items.eq(slider.realIndex).addClass('is-active');
			});
		},
	},
	characteristics: {
		init($characteristics) {
			if (vars.isMobile()) {
				new Swiper($characteristics.find('.swiper-container')[0], {
					loop: true,
					navigation: {
						prevEl: $characteristics.find(".characteristics__prev")[0],
						nextEl: $characteristics.find(".characteristics__next")[0]
					},
					pagination: {
						el: $characteristics.find('.characteristics__pager')[0],
						clickable: true,
					},
				});
			}
		},
	},
	infrastructure: {
		init($infrastructure) {
			const $map = $infrastructure.find('.infrastructure__map');
			const options = $map.data();
			const $items = $infrastructure.find('.infrastructure__item');
			const init = () => {
				app.scriptLoading('//api-maps.yandex.ru/2.1/?lang=ru_RU', () => {
					ymaps.ready(() => {
						const map = new ymaps.Map($map[0], {
							center: [options.lat, options.lng],
							zoom: options.zoom,
							controls: [],
						}, {});
	
						const setMarkers = () => {
							let $needItems = $items;
	
							if (!$needItems.filter('[data-type="all"]').hasClass('is-active')) {
								$needItems = $needItems.filter('.is-active');
							}
	
							$needItems.each((index, item) => {
								const $item = $(item);
								const itemOptions = $item.data().options;
	
								if (itemOptions) {
									$.each(itemOptions.items, (index2, item2) => {
										map.geoObjects.add(new ymaps.Placemark([item2.lat, item2.lng], {
											balloonContent: `
												<div class="infrastructure__info">
													<div class="infrastructure__info__title">
														${itemOptions.label}
													</div>
													<div class="infrastructure__info__name">
														${item2.name}
													</div>
													<div class="infrastructure__info__address">
														${item2.address}
													</div>
													<div class="infrastructure__info__link">
														<a href="https://yandex.ru/maps/?ll=${item2.lng}%2C${item2.lat}&mode=routes&rtext=~${item2.lat}%2C${item2.lng}&z=16" target="_blank">Открыть на Яндекс.Картах</a>
													</div>
												</div>
											`,
										}, {
											iconLayout: 'default#image',
											iconImageHref: itemOptions.icon,
											iconImageSize: [31, 31],
											iconImageOffset: [-16, -16],
											hideIconOnBalloonOpen: false,
										}));
									});
								}
							});
						}
	
						const setLogo = () => {
							map.geoObjects.add(new ymaps.Placemark([options.lat, options.lng], {}, {
								iconLayout: 'default#image',
								iconImageHref: options.logo,
								iconImageSize: [56, 56],
								iconImageOffset: [-28, -28],
							}));
						}
	
						setMarkers();
						setLogo();
	
						$items.on('click', (e) => {
							const $item = $(e.currentTarget);
	
							if ($item.data('type') === 'all') {
								if ($item.hasClass('is-active')) {
									$items.removeClass('is-active');
								} else {
									$items.addClass('is-active');
								}
							} else {
								if ($item.hasClass('is-active')) {
									if ($items.filter('.is-active').length === $items.length) {
										$items.removeClass('is-active');
										$item.addClass('is-active');
									} else {
										$item.removeClass('is-active');
									}
								} else {
									$item.addClass('is-active');
								}
	
								$items.filter('[data-type="all"]').removeClass('is-active');
	
								if ($items.filter('.is-active').length === $items.length - 1) {
									$items.filter('[data-type="all"]').addClass('is-active');
								}
							}
	
							map.geoObjects.removeAll();
							setMarkers();
							setLogo();
						});
					});
				});
			};

			$window.on('scroll.infrastructure', () => {
				if ($window.scrollTop() + $window.outerHeight() > $infrastructure.offset().top) {
					init();
					$window.off('scroll.infrastructure');
				}
			}).trigger('scroll.infrastructure');

			$infrastructure.find('.infrastructure__arrow').on('click', (e) => {
				e.preventDefault();

				$infrastructure.toggleClass('is-show-list');
			});
		},
	},
	scriptLoading(src, callback) {
		let script = document.createElement('script');

		let loaded;

		script.setAttribute('src', src);
		if (callback) {
			script.onreadystatechange = script.onload = () => {
				if (!loaded) {
					callback();
				}
				loaded = true;
			};
		}
		document.getElementsByTagName('head')[0].appendChild(script);
	},
	form: {
		init($form) {
			$form.find('button[type="submit"]').on('click', () => {
				$form.addClass('is-show-valid');
			});
		},
	},
	formOld: {
		init($form) {
			$form.find('button[type="submit"]').on('click', () => {
				$form.addClass('is-show-valid');
			});

			$form.on('submit', (e) => {
				e.preventDefault();
				$.ajax({
					type: $form.attr('method'),
					url: $form.attr('action'),
					data: $form.serialize(),
					dataType: 'json',
					success(result) {
						if (result.result === 1) {
							$form[0].reset();
							$.fancybox.close();
						}

						if ($form.data('type') === 'inline') {
							$form.addClass('is-success');
							$form.find('.js-form-success-text').text(result.message);
						} else {
							$.fancybox.open({
								src: $form.data('success'),
								opts: {
									autoFocus: false,
									backFocus: false,
									touch: false,
								},
							});
						}
						$form.removeClass('is-show-valid');
					},
				});
			});
		},
	},
	numberWithSpaces(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	},
	numberWithoutSpaces(x) {
		return parseInt(x.toString().replace(/ /g, ''), 10);
	},
	catalog: {
		init($catalog) {
			const $tabs = $catalog.find('.catalog__tabs-list a');

			const $tabItems = $catalog.find('.catalog__tab-item');

			const $houseList = $catalog.find('.catalog__house__list a');

			const $floorTab = $catalog.find('.catalog__floor__tab');

			const $floorApartment = $catalog.find('.catalog__floor__apartment');

			const $floorType = $catalog.find('.catalog__floor__type a');

			const $apartment = $catalog.find('.catalog__apartment');

			const $apartmentSlider = $apartment.find('.catalog__apartment__slider');

			const $apartmentNav = $apartment.find('.catalog__apartment__nav');

			const apartmentsTemplate = $('#catalogApartments').html();

			const $filterRooms = $catalog.find('.catalog__parameters__filter__rooms__item input');

			const $filterFloor = $catalog.find('.catalog__parameters__filter__floor__item input');

			const $filterPrice = $catalog.find('.catalog__parameters__filter__price');

			const $filterArea = $catalog.find('.catalog__parameters__filter__area');

			const $filterClear = $catalog.find('.catalog__parameters__filter__clear');

			const $filterSubmit = $catalog.find('.catalog__parameters__filter__submit');

			const $parametersList = $catalog.find('.catalog__parameters__list table tbody');

			const $parametersNoResult = $catalog.find('.catalog__parameters__list__no-result');

			const $parametersListMore = $catalog.find('.catalog__parameters__list__more');

			const $sort = $catalog.find('.catalog__parameters__list__sort');

			const parametersTemplate = $('#catalogParameters').html();

			const apartmentTemplate = $('#apartment').html();

			let data;

			let type = $tabs.filter('.is-active').data('type');

			let filter = {
				rooms: [],
				floor: [],
				price: [],
				area: [],
				pager: {
					start: 0,
					end: 10,
					step: 10,
				},
			};

			let sort = {
				name: '',
				type: 0,
			};

			let filterData = {
				list: [],
			};

			let filter2 = {
				rooms: [],
				floor: [],
				apartment: [],
			};

			const setApartmentsParams = () => {
				const set = () => {
					let pagerData = {
						list: [],
					};

					filterData.list = [];

					$.each(data.list, (index, item) => {
						let push = true;

						if (filter.rooms.length) {
							let pushRooms = false;

							$.each(filter.rooms, (indexRooms, itemRooms) => {
								if (itemRooms === item.rooms) {
									pushRooms = true;
								}
							});

							if (!pushRooms) {
								push = false;
							}
						}

						if (filter.floor.length) {
							let pushFloor = false;

							$.each(filter.floor, (indexFloor, itemFloor) => {
								if (itemFloor === item.floor) {
									pushFloor = true;
								}
							});

							if (!pushFloor) {
								push = false;
							}
						}

						if (filter.price.length) {
							if (item.cost) {
								if (filter.price[0] > app.numberWithoutSpaces(item.cost) || filter.price[1] < app.numberWithoutSpaces(item.cost)) {
									push = false;
								}
							}
						}

						if (filter.area.length) {
							if (filter.area[0] > item.area.total || filter.area[1] < item.area.total) {
								push = false;
							}
						}

						if (push) {
							filterData.list.push(item);
						}
					});

					if (sort.name) {
						filterData.list.sort((a, b) => {
							if (sort.type) {
								if (sort.name === 'area') {
									return b[sort.name].total - a[sort.name].total;
								} else {
									return parseFloat(app.numberWithoutSpaces(b[sort.name])) - parseFloat(app.numberWithoutSpaces(a[sort.name]));
								}
							} else {
								if (sort.name === 'area') {
									return a[sort.name].total - b[sort.name].total;
								} else {
									return parseFloat(a[sort.name]) - parseFloat(b[sort.name]);
								}
							}
						});
					}

					filter.pager.start = 0;
					filter.pager.end = filter.pager.step;

					pagerData.list = filterData.list.filter((e, i) => {
						if (filter.pager.start === 0) {
							return i >= filter.pager.start && i <= filter.pager.end;
						} else {
							return i > filter.pager.start && i <= filter.pager.end;
						}
					});

					pagerData.list.forEach(item => {
						item.cost = app.numberWithSpaces(item.cost);
					});

					$parametersList.html(Handlebars.compile(parametersTemplate)(pagerData));

					if (pagerData.list.length === 0) {
						$parametersNoResult.removeClass('is-hidden');
					} else {
						$parametersNoResult.addClass('is-hidden');
					}

					if (filterData.list[filter.pager.end + 1]) {
						$parametersListMore.show();
					} else {
						$parametersListMore.hide();
					}
				}

				if (data) {
					set();
				} else {
					$.ajax({
						type: 'get',
						url: $catalog.data('ajax'),
						dataType: 'json',
						success(response) {
							data = response;
							set();
						},
					});
				}
			};

			const pageApartmentsParams = () => {
				let pagerData = {
					list: [],
				};

				filter.pager.start += filter.pager.step;
				filter.pager.end += filter.pager.step;

				pagerData.list = filterData.list.filter((e, i) => {
					if (filter.pager.start === 0) {
						return i >= filter.pager.start && i <= filter.pager.end;
					} else {
						return i > filter.pager.start && i <= filter.pager.end;
					}
				});

				pagerData.list.forEach(item => {
					item.cost = app.numberWithSpaces(item.cost);
				});

				$parametersList.append(Handlebars.compile(parametersTemplate)(pagerData));

				if (filterData.list[filter.pager.end + 1]) {
					$parametersListMore.show();
				} else {
					$parametersListMore.hide();
				}
			};

			const setApartmentsLayout = () => {
				let newData = {
					list: [],
				};

				$.each(data.list, (index, item) => {
					let push = true;

					if (filter2.rooms.length) {
						let pushRooms = false;

						$.each(filter2.rooms, (indexRooms, itemRooms) => {
							if (itemRooms === item.rooms) {
								pushRooms = true;
							}
						});

						if (!pushRooms) {
							push = false;
						}
					}

					if (filter2.floor.length) {
						let pushFloor = false;

						$.each(filter2.floor, (indexFloor, itemFloor) => {
							if (itemFloor === item.floor) {
								pushFloor = true;
							}
						});

						if (!pushFloor) {
							push = false;
						}
					}

					if (filter2.apartment.length) {
						let pushApartment = false;

						$.each(filter2.apartment, (indexApartment, itemApartment) => {
							if (itemApartment === item.number) {
								pushApartment = true;
							}
						});

						if (!pushApartment) {
							push = false;
						}
					}

					if (push) {
						if (item.cost) {
							item.cost = app.numberWithSpaces(item.cost);
						}
						newData.list.push(item);
					}
				});

				$apartmentSlider.html(Handlebars.compile(apartmentsTemplate)(newData));

				$apartment.addClass('is-show');
				if (newData.list.length > 1) {
					$apartmentNav.show();
					new Swiper($apartmentSlider.find('.swiper-container')[0], {
						loop: true,
						navigation: {
							prevEl: $apartment.find('.catalog__apartment__prev')[0],
							nextEl: $apartment.find('.catalog__apartment__next')[0],
						},
						pagination: {
							el: $apartment.find('.catalog__apartment__pager')[0],
							clickable: true,
						},
					});
				} else {
					$apartmentNav.hide();
				}

				window.scrollTo(0, $apartment.offset().top - $('.header').outerHeight());
			};

			const initRelated = () => {
				$('.apartment__related__slider').each((index, item) => {
					new Swiper($(item).find('.swiper-container')[0], {
						slidesPerView: 'auto',
						spaceBetween: 20,
						navigation: {
							prevEl: $(item).find('.apartment__related__prev')[0],
							nextEl: $(item).find('.apartment__related__next')[0],
						},
						pagination: {
							el: $(item).find('.apartment__related__pager')[0],
							clickable: true,
						},
					});
				});
			};

			initRelated();

			const showApartment = (number) => {
				let apartmentData = {
					item: {},
					related: [],
				};

				data.list.forEach(item => {
					if (item.number === number) {
						apartmentData.item = item;
						if (apartmentData.item.cost) {
							apartmentData.item.cost = app.numberWithSpaces(apartmentData.item.cost);
						}
					}
				});

				data.list.forEach(item => {
					if (item.number !== number && item.floor === apartmentData.item.floor) {
						apartmentData.related.push(item);
					}
				});

				$.fancybox.close();

				$.fancybox.open(Handlebars.compile(apartmentTemplate)(apartmentData), {
					autoFocus: false,
					backFocus: false,
					touch: false,
					afterShow() {
						$('.apartment__gallery__item').each((index, item) => {
							let $item = $(item);
		
							if ($item.find('.swiper-slide').length > 1) {
								new Swiper($item.find('.swiper-container')[0], {
									loop: true,
									navigation: {
										prevEl: $item.find('.apartment__gallery__prev')[0],
										nextEl: $item.find('.apartment__gallery__next')[0],
									},
									pagination: {
										el: $item.find('.apartment__gallery__pager')[0],
										clickable: true,
									},
								});
							} else {
								$item.find('.apartment__gallery__prev').remove();
								$item.find('.apartment__gallery__next').remove();
							}
						});
		
						initRelated();
		
						$('.apartment__tabs-list a').on('click', (e) => {
							let $this = $(e.currentTarget);
							let $target = $(`.apartment__gallery__item[data-item="${$(e.currentTarget).data('item')}"]`);
		
							e.preventDefault();
		
							$('.apartment__tabs-list a').removeClass('is-active')
							$('.apartment__gallery__item').removeClass('is-active');
							$this.addClass('is-active');
							$target.addClass('is-active');
		
							if ($target.find('.swiper-container').length && $target.find('.swiper-container')[0].swiper) {
								$target.find('.swiper-container')[0].swiper.update();
							}
						});

						$('.apartment__card__set-apartment').on('click', (e) => {
							let $this = $(e.currentTarget);

							let $target = $($this.attr('href'));

							let $title = $target.find('.questions__title');

							let $field = $target.find('.js-book-now-apartment');

							$title.text(`${$this.data('label')}${$this.data('apartment')}`);
							$this.val($this.data('apartment'));
						});
					},
				});
			};

			$tabs.on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				$tabs.removeClass('is-active');
				$tabItems.removeClass('is-active');
				$this.addClass('is-active');
				$tabItems.filter(`[data-item="${$this.data('type')}"]`).addClass('is-active');
				if ($this.data('type') === 'parameters') {
					setApartmentsParams();
				}
			});

			$floorTab.each((index, item) => {
				new Swiper($(item).find('.catalog__floor__image .swiper-container')[0], {
					slidesPerView: 'auto',
					freeMode: true,
					roundLengths: true,
					freeModeMomentumRatio: 0.1,
					grabCursor: true,
					scrollbar: {
						el: $(item).find('.catalog__floor__image-scroll')[0],
						draggable: true,
						snapOnRelease: false,
					},
				});
			});

			$houseList.on('click', (e) => {
				const $needTab = $floorTab.filter(`[data-tab="${$(e.currentTarget).data('tab')}"]`);
				e.preventDefault();

				filter2.floor = [$(e.currentTarget).data('tab')];
				$houseList.removeClass('is-active');
				$(e.currentTarget).addClass('is-active');
				$floorTab.removeClass('is-active');
				$needTab.addClass('is-active');
				$needTab.find('.swiper-container')[0].swiper.update();
				$apartment.removeClass('is-show');
				$floorApartment.removeClass('is-active is-disabled');
				$floorType.removeClass('is-active');
				window.scrollTo(0, $catalog.find('.catalog__floor').offset().top - $('.header').outerHeight());
			});

			$floorApartment.on('click', (e) => {
				e.preventDefault();

				filter2.rooms = [];
				filter2.apartment = [$(e.currentTarget).data('apartment')];

				$floorType.removeClass('is-active');
				$floorApartment.removeClass('is-active').addClass('is-disabled');
				$(e.currentTarget).removeClass('is-disabled').addClass('is-active');
				if (data) {
					setApartmentsLayout();
				} else {
					$.ajax({
						type: 'get',
						url: $catalog.data('ajax'),
						dataType: 'json',
						success(response) {
							data = response;
							setApartmentsLayout();
						},
					});
				}
			});

			$floorType.on('click', (e) => {
				e.preventDefault();

				filter2.rooms = [$(e.currentTarget).data('type')];
				filter2.apartment = [];

				$floorApartment.removeClass('is-active is-disabled');
				$floorType.removeClass('is-active');
				$(e.currentTarget).addClass('is-active');
				if (data) {
					setApartmentsLayout();
				} else {
					$.ajax({
						type: 'get',
						url: $catalog.data('ajax'),
						dataType: 'json',
						success(response) {
							data = response;
							setApartmentsLayout();
						},
					});
				}
			});

			if ($filterPrice.length) {
				noUiSlider.create($filterPrice[0], {
					start: [parseInt($filterPrice.data('min'), 10), parseInt($filterPrice.data('max'), 10)],
					connect: true,
					tooltips: [true, true],
					range: {
						min: parseInt($filterPrice.data('min'), 10),
						max: parseInt($filterPrice.data('max'), 10),
					},
					format: wNumb({
						decimals: 0,
						thousand: ' ',
					}),
				});

				$filterPrice[0].noUiSlider.on('update', (values) => {
					filter.price = [app.numberWithoutSpaces(values[0]), app.numberWithoutSpaces(values[1])];
				});
			}

			if ($filterArea.length) {
				noUiSlider.create($filterArea[0], {
					start: [parseInt($filterArea.data('min'), 10), parseInt($filterArea.data('max'), 10)],
					connect: true,
					tooltips: [true, true],
					range: {
						min: parseInt($filterArea.data('min'), 10),
						max: parseInt($filterArea.data('max'), 10),
					},
					format: wNumb({
						decimals: 0,
						postfix: $filterArea.data('postfix'),
					}),
				});

				$filterArea[0].noUiSlider.on('update', (values) => {
					filter.area = [parseInt(values[0], 10), parseInt(values[1], 10)];
				});
			}

			$filterRooms.on('change', () => {
				filter.rooms = [];

				$filterRooms.filter(':checked').each((index, item) => {
					filter.rooms.push(parseInt($(item).val()));
				});
			});

			$filterFloor.on('change', () => {
				filter.floor = [];

				$filterFloor.filter(':checked').each((index, item) => {
					filter.floor.push(parseInt($(item).val()));
				});
			});

			$parametersListMore.on('click', (e) => {
				e.preventDefault();

				pageApartmentsParams();
			});

			$filterSubmit.on('click', (e) => {
				e.preventDefault();

				setApartmentsParams();
			});

			$filterClear.on('click', (e) => {
				e.preventDefault();

				$filterRooms.prop('checked', false).trigger('change');
				$filterFloor.prop('checked', false).trigger('change');
				if ($filterPrice.length) {
					$filterPrice[0].noUiSlider.set([parseInt($filterPrice.data('min'), 10), parseInt($filterPrice.data('max'), 10)]);
				}
				if ($filterArea.length) {
					$filterArea[0].noUiSlider.set([$filterArea.data('min'), $filterArea.data('max')]);
				}

				setApartmentsParams();
			});

			$parametersNoResult.find('a').on('click', (e) => {
				e.preventDefault();

				$filterRooms.prop('checked', false).trigger('change');
				$filterFloor.prop('checked', false).trigger('change');
				if ($filterPrice.length) {
					$filterPrice[0].noUiSlider.set([$filterPrice.data('min'), $filterPrice.data('max')]);
				}
				if ($filterArea.length) {
					$filterArea[0].noUiSlider.set([$filterArea.data('min'), $filterArea.data('max')]);
				}

				setApartmentsParams();
			});

			$sort.on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				if ($this.hasClass('is-active')) {
					if ($this.hasClass('is-desc')) {
						$this.removeClass('is-active is-desc');
						sort.name = '';
					} else {
						$this.addClass('is-desc');
						sort.type = 1;
					}
				} else {
					$sort.removeClass('is-active is-desc')
					$this.addClass('is-active');
					sort.name = $this.data('name');
					sort.type = 0;
				}
				setApartmentsParams();
			});

			if (type === 'parameters') {
				setApartmentsParams();
			}

			$document.on('click', '.catalog__apartment__item__btn a, .apartment__related__item, .catalog__parameters__item', (e) => {
				e.preventDefault();
				if (data) {
					showApartment($(e.currentTarget).data('number'));
				} else {
					$.ajax({
						type: 'get',
						url: $catalog.data('ajax'),
						dataType: 'json',
						success(response) {
							data = response;
							showApartment($(e.currentTarget).data('number'));
						},
					});
				}
			});
		},
	},
};

app.global.init();

window.initApps = () => {
	$('[data-app]').each((index, item) => {
		let $this = $(item);

		let split = $this.data('app').split('||');

		$.each(split, (appIndex, appName) => {
			let appNameCamel = false;

			if (appName.indexOf('-') !== -1) {
				appNameCamel = appName.replace(/(-|\s)(\S)/ug, (m) => m.toUpperCase()).replace(/-/ug, '');
			}

			if (app[appName] && $this.data(`${appName}-init`) !== true) {

				app[appName].init($this);
				$this.data(`${appName}-init`, true);
			} else if (app[appNameCamel] && $this.data(`${appName}-init`) !== true) {
				app[appNameCamel].init($this);
				$this.data(`${appName}-init`, true);
			}
		});
	});
};

initApps();
